module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topic_article_container"
  }, [(_vm.show === 'recommend') ? _c('div', {
    staticClass: "sequence-nav"
  }, [_c('a', {
    class: {
      active: _vm.change === 'new'
    },
    on: {
      "click": function($event) {
        _vm.sortContent('time'), _vm.change = 'new'
      }
    }
  }, [_vm._v("最新更新  ·")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.change === 'hot'
    },
    on: {
      "click": function($event) {
        _vm.change = 'hot'
      }
    }
  }, [_vm._v("热门排序  ·")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.change === 'concern'
    },
    on: {
      "click": function($event) {
        _vm.sortContent('concern'), _vm.change = 'new'
      }
    }
  }, [_vm._v("关注度排序")])]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.topic), function(content) {
    return _c('li', [_c('a', {
      staticClass: "topic_article_img",
      attrs: {
        "href": ""
      }
    }, [_c('img', {
      attrs: {
        "src": content.img
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "topic_content"
    }, [_c('h5', [_vm._v(_vm._s(content.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(content.par))]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('p', [_c('a', {
      staticStyle: {
        "color": "#4094c7"
      },
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(content.number) + "篇文章")]), _vm._v("\n\t\t\t\t\t  ·  " + _vm._s(content.concern) + "k人关注\n\t\t\t\t\t"), _c('span', {
      staticClass: "topic_tag"
    }, [_c('i', {
      staticClass: "fa fa-tags"
    }), _vm._v(_vm._s(content.keys))])])])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topic_button"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus"
  }), _c('span', [_vm._v("添加关注")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44e25a33"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topic_article.vue
// module id = 62
// module chunks = 0